import { PairingListScreen } from '../features/pairings/screens/PairingListScreen';

export const PairingListPage = () => {
  return <PairingListScreen />;
};
